import { graphql } from '@/gql';
import type { AddPartnerPaymentSourceMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const addPartnerPaymentSource = async ({ codeName, setupIntentId }: AddPartnerPaymentSourceMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AddPartnerPaymentSource($codeName: String!, $setupIntentId: String!) {
        addPartnerPaymentSource(setupIntentId: $setupIntentId, codeName: $codeName)
      }
    `),
    variables: {
      codeName,
      setupIntentId,
    },
  });

  return response.data?.addPartnerPaymentSource ?? false;
};
